module.exports = __webpack_public_path__ + "img/wallace-college.9070a6c9.jpg";